export const AI_TEXT_CONTEXT = 'template-text';
